import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './MobileSidebar.module.scss';
import Typography from '../../kit/atoms/Typography/Typography';
import SvgCross from '../../kit/icons/Cross';
import SelectWithLabels from '../../kit/atoms/SelectWithLabels/SelectWithLabels';
import Accordion from '../../components/Accordion/Accordion';
import { FacetData, Filter, LimiterOption } from '../../types';
import AppliedFilters from '../../components/AppliedFilters/AppliedFilters';
import { Facet } from '../../types';

export interface MobileSidebarProps extends React.PropsWithChildren<any> {
    isOpen: boolean;
    limiterOptions?: LimiterOption[];
    facetsData?: Facet[];
    activeFilters: FacetData[];
    handleToggleFilter;
    currentLimit: string;
    isItemActive: (facetName: string, value: string) => boolean;
    onClose?: () => void;
    onLimiterChange?: (selectedValue: string) => void;
    handleRemoveFilter: (facetName: string, value: string) => void;
    clearAllFilters: () => void;
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({
    isOpen,
    limiterOptions,
    facetsData,
    activeFilters,
    currentLimit,
    handleToggleFilter,
    isItemActive,
    onClose,
    onLimiterChange,
    handleRemoveFilter,
    clearAllFilters
}) => {
    const st: CssModuleType = currentCssModule;
    const { t } = useTranslation();

    return (
        <>
            <div className={clsx(st['mobile-sidebar'], isOpen ? st.open : '')}>
                <div className={st['mobile-sidebar__content']}>
                    <div className={st['mobile-sidebar__heading']}>
                        <Typography variant='h3'>Filters</Typography>
                        <SvgCross
                            className={st['mobile-sidebar__close']}
                            data-dismiss='modal'
                            onClick={onClose}
                            size={12}
                        />
                    </div>
                    <div className={st['mobile-sidebar__filters']}>
                        {activeFilters.length > 0 ? (
                            <Typography className={st.filtered}>
                                Filtered by
                            </Typography>
                        ) : null}
                        <AppliedFilters
                            filters={activeFilters}
                            onRemoveFilter={handleRemoveFilter}
                            clearAllFilters={clearAllFilters}
                            mobileSidebarStyles
                        />
                    </div>
                    <SelectWithLabels
                        minWidth
                        options={limiterOptions}
                        beforeLabel={t('/Search/Show')}
                        onChange={onLimiterChange}
                        defaultValue={currentLimit}
                    />
                    <Accordion
                        data={facetsData}
                        onToggle={handleToggleFilter}
                        isItemActive={isItemActive}
                    />
                    <div
                        className={st['mobile-sidebar__show-results']}
                        onClick={onClose}
                    >
                        <Typography>Show results</Typography>
                    </div>
                </div>
            </div>
            <div
                className={clsx(
                    st['mobile-sidebar__overlay'],
                    isOpen ? st.open : ''
                )}
                onClick={onClose}
            ></div>
        </>
    );
};

export default MobileSidebar;
